module.exports = __webpack_public_path__ + "media/images/bg-plant-right-19161ca05aed91e120e127468ce4ccd8.png";